export default __webpack_public_path__ + "static/media/1_16_logo.c700ad19.png";